<template>
    <div class="image__slider">
        <div class="slider__inner" >
            <div class="preview__part" v-if="images && images.length > 0">
                <div class="prev nav-button" v-on:click="prev"></div>
                <div class="next nav-button" v-on:click="next"></div>
                <div class="preview__image">
                    <div class="current__img--wrapper" :style="{ backgroundImage: `url('${images[index]}')`}" v-on:click="toggleLightbox()">
                    </div>
                </div>
            </div>
            <div class="content__part" v-if="images && images.length > 0">
                <div class="slider__track">
                    <div class="slide" v-for="(image, ind) in images">
                        <div class="slide__img" v-bind:class="{ active: index == ind }" :style="{ backgroundImage: `url('${image}')`}" v-on:click="jumpTo(ind)">

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "Slider",
        components: {

        },
        props: {
            images: Array,
            maxImages: Number,
            maxSize: Number,
            lightbox: false
        },
        data(){
            return{
                index: 0,
                msg: "",
                confirm: false,
                upload: false,
                selectedImagesToUpload: "",
                error: "",

            }
        },
        methods: {
            next(){
                if(this.images){
                    if(this.index < this.images.length -1){
                        this.index++;
                    } else {
                        this.index = 0;
                    }
                }
            },
            prev(){
                if(this.images){
                    if(this.index > 0){
                        this.index--;
                    } else {
                        this.index = this.images.length -1;
                    }
                }
            },
            jumpTo(i){
                this.index = i;
            },
            removeItem(){
                if(this.index == (this.images.length -1) && this.index >= 0){
                    let savedIndex = this.index;
                    this.index--;
                    this.$parent.removeImage(this.images[savedIndex]);

                } else {
                    this.$parent.removeImage(this.images[this.index]);
                }

            },
            toggleLightbox(){
                console.log(this.$parent)
                this.$parent.toggleLightbox();
            },
            openConfirm(){
                this.confirm = true;
            },
            openUpload(){
                this.upload = true;
            },
            openChooser(){
                document.querySelector('.hidden__input').click();
            },
            previewFiles(){
                if(this.$refs.filesToUpload.files.length > this.maxImages){
                    this.error = "Bitte nur maximal 6 Bilder hochladen";
                    return;
                } else {
                    this.error = null;
                }
                for(let i = 0; i < this.$refs.filesToUpload.files.length; i++){
                    if (!this.$refs.filesToUpload.files[i].type.match('image.*')) {
                        this.error = 'Bitte gültige Bilder auswählen.';
                        return;
                    }
                    console.log(this.$refs.filesToUpload.files[i])
                    if(this.$refs.filesToUpload.files[i].size > this.maxSize){
                        this.error = this.$t("Angebot.BilderuploadError01")+ (this.maxSize/1000000) +this.$t("Angebot.BilderuploadError02");
                        return;
                    }
                }
                this.selectedImagesToUpload = this.$refs.filesToUpload.files;
            },
            onDrop: function(e) {
                e.stopPropagation();
                e.preventDefault();

                let files = e.dataTransfer.files;
                if(files.length > this.maxImages){
                    this.error = "Bitte nur maximal "+ this.maxImages +" Bilder hochladen";
                    return;
                } else {
                    this.error = null;
                }

                for(let i = 0; i < files.length; i++){
                    if (!files[i].type.match('image.*')) {
                        this.error = 'Bitte gültige Bilderformate auswählen.';
                        return;
                    }
                    if(files[i].size > this.maxSize){
                        this.error = this.$t("Angebot.BilderuploadError01")+ (this.maxSize/1000000) +this.$t("Angebot.BilderuploadError02");
                        return;
                    }
                }

                this.selectedImagesToUpload = e.dataTransfer.files;

            },
            onUpload(){
                this.index = 0;
                this.upload = false;
                this.$parent.selectImages(this.selectedImagesToUpload);
            },
            confirmRemove(state){
                if(state){
                    this.confirm = false;
                    this.removeItem();
                } else {
                    this.confirm = false;
                }
            }
        },
        created() {
        }
    }
</script>

<style scoped lang="scss">

    .image__slider-lightbox{
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255, 255, 255, 0.95);
        z-index: 22;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        transition: 0.4s ease;
        &.active{
            opacity: 1;
            visibility: visible;
            pointer-events: all;
        }

    }
    .image__slider{

        .preview__part{
            position: relative;
        }
        .slider__inner{
            padding: 50px;
        }
        .nav-button{
            position: absolute;
            top: 50%;
            transform: translate(-50%, -50%);
            cursor: pointer;
            &.next{
                left: calc(100% + 25px);
                &:before{
                    display: block;
                    content: "";
                    width: 15px;
                    height: 15px;
                    border-top: 2px solid black;
                    border-right: 2px solid black;
                    transform: translate(-50%, -50%) rotate(45deg);
                    transform-origin: center;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                }
            }
            &.prev{
                left: -25px;
                &:before{
                    display: block;
                    content: "";
                    width: 15px;
                    height: 15px;
                    border-top: 2px solid black;
                    border-left: 2px solid black;
                    transform: translate(-50%, -50%) rotate(-45deg);
                    transform-origin: center;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                }
            }
        }
        .preview__image{
            max-height: 600px;
            overflow: hidden;
            margin-bottom: 25px;
            border-bottom: 1px solid black;
            .preview__image-remove{
                position: absolute;
                right: 15px;
                top: 15px;
                border: 1px solid darkgrey;
                border-radius: 50%;
                background-color: white;
                height: 30px;
                width: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;

                .inner{
                    width: 20px;
                    height: 20px;
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    &:before{
                        position: absolute;
                        content: '';
                        width: 100%;
                        height: 2px; /* cross thickness */
                        background-color: black;
                        transform:rotate(45deg);
                    }
                    &:after{
                        position: absolute;
                        content: '';
                        width: 100%;
                        height: 2px; /* cross thickness */
                        background-color: black;
                        transform:rotate(-45deg);
                    }
                }

            }
            .current__img--wrapper{
                height: 600px;
                width: 100%;
                background-position: center center;
                background-repeat: no-repeat;
                background-size: cover;
            }
            .current__img{
                width: 100%;
                height: auto;
            }
        }
        .slider__track{
            margin-top: 30px;
            display: flex;
            height: 150px;
            overflow: hidden;
            width: 100%;
            .slide{
                width: 14.6%;
                margin: 0 1%;
                display: block;
                &:first-of-type{
                    margin-left: 0px;
                }
                &:last-of-type{
                    margin-right: 0px;
                }
                .slide__img{
                    width: 100%;
                    height: 80px;
                    display: block;
                    background-position: center center;
                    background-repeat: no-repeat;
                    background-size: cover;
                    &.active{
                        border: 1px solid #acacac;
                        box-shadow: 0px 0px 4px 1px #acacac;
                    }
                }
            }
        }

    }

</style>